import { render, staticRenderFns } from "./VPIGraph.vue?vue&type=template&id=fa2c5c60&scoped=true&"
import script from "./VPIGraph.vue?vue&type=script&lang=js&"
export * from "./VPIGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2c5c60",
  null
  
)

export default component.exports